var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar-title',{staticClass:"text-center mt-5 mb-5 text-wrap"},[(_vm.title == 'Admin')?_c('h2',[_vm._v(" Sistema de controle de eventos para confirmação de presença ")]):_c('h2',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }